import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUnreadCount } from '../../actions/notifications';
import { styled, useTheme } from '@mui/material/styles';
import { Link, useLocation  } from 'react-router-dom';
import Box from '@mui/material/Box';
import { Badge } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InventoryIcon from '@mui/icons-material/Inventory';
import SearchIcon from '@mui/icons-material/Search';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import HistoryIcon from '@mui/icons-material/History';
import useMediaQuery from '@mui/material/useMediaQuery';

const drawerWidth = 240;



const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create('width', {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: 'hidden',
//   width: `calc(${theme.spacing(10)} + 1px) !important`,
//   [theme.breakpoints.up('sm')]: {
//     width: `calc(${theme.spacing(8)} + 1px) !important`,
//   },
// });

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',

  // MOBILE (xs): smallest
  width: `calc(${theme.spacing(7)} + 1px)`,

  // >= sm: slightly bigger (or whatever you want)
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },

  // >= md: your current “closed” desktop size (optional)
  [theme.breakpoints.up('md')]: {
    width: `calc(${theme.spacing(10)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    variants: [
      {
        props: ({ open }) => open,
        style: {
          ...openedMixin(theme),
          '& .MuiDrawer-paper': openedMixin(theme),
        },
      },
      {
        props: ({ open }) => !open,
        style: {
          ...closedMixin(theme),
          '& .MuiDrawer-paper': closedMixin(theme),
        },
      },
    ],
  }),
);


const MiniDrawer = ({open, setOpen }) => {
    const location = useLocation();
  const theme = useTheme();


const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

const dispatch = useDispatch();
const user = useSelector(state => state.user);
const unreadCount = useSelector(state => state?.notifications?.unread);

React.useEffect(() => {
  if (!user.id) return;
  const refresh = () => dispatch(fetchUnreadCount(user.id));

  // 1) Grab latest immediately
  refresh();

  // 2) Refresh when the tab regains focus
  const onFocus = () => refresh();
  window.addEventListener('focus', onFocus);

  // 3) Safety net: refresh every 1 hour while focused
  const interval = setInterval(refresh, 10 * 1000);

  return () => {
    window.removeEventListener('focus', onFocus);
    clearInterval(interval);
  };
}, [dispatch, user.id]);


console.log(open);

const items = [
  { path: '/dashboard',  label: 'Dashboard', icon: <DashboardIcon /> },
  { path: '/inventory',  label: 'Inventory', icon: <InventoryIcon /> },
  { path: '/search',      label: 'Search',     icon: <SearchIcon /> },
  { path: '/sales', label:'Sales', icon:<ShoppingCartIcon />},
  { path: '/history', label:'History', icon:<HistoryIcon />},
  { path: '/reports', label:'Reports', icon:<AssessmentOutlinedIcon />},
  { path: '/alerts',      label: 'Alerts',  icon: (
    <Badge badgeContent={unreadCount} sx={{
    '& .MuiBadge-badge': {
      backgroundColor: 'red', 
      color: 'white', 
    }}}>
      <NotificationsIcon />
    </Badge>
   )
 },

];


  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Drawer variant="permanent" open={open}>
        <DrawerHeader sx={{height:'74px', border:'none'}}>
        </DrawerHeader>
        <Divider />

            {items.map(({ path, label, icon }) => {
    const isActive = location.pathname === path;
    return (
      <ListItem key={path} disablePadding sx={{ display: 'block', padding:'8px' }}>
        <ListItemButton
        onClick={() => setOpen(false)} 
          component={Link}
          to={path}
          sx={{
            background: isActive && 'rgba(25, 118, 210, 0.1)',
            borderRadius:'8px',
            // minHeight: 48,
            justifyContent: open ? 'initial' : 'center',
            flexDirection:open ? 'row' : 'column',
            fontSize:'10px',
            px: 2.5,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              justifyContent: 'center',
              mr: open && 2 ,
              color: isActive
                ? theme.palette.primary.main
                : '#6b7280',
            }}
          >
            {icon}
          </ListItemIcon>
          <Typography sx={{ display: (isMobile && !open)  ? 'none' : 'block', fontSize: !open && '11px', color: isActive ? theme.palette.primary.main : '#333' }}>{label}</Typography>
        </ListItemButton>
      </ListItem>
    );
  })}

      </Drawer>
    </Box>
  );
}

export default MiniDrawer;
